<template>
  <div v-if="showStreetView" class="fixed top-0 z-40 m-fixed-right-4">
    <button @click="close" class="mr-2 mt-16 p-2 mb-20 flex justify-center items-center bg-white border border-section_border rounded-lg shadow-sm">
      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 96 960 960" width="24"><path d="m249 849-42-42 231-231-231-231 42-42 231 231 231-231 42 42-231 231 231 231-42 42-231-231-231 231Z"/></svg>
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { gmapApi } from 'vue2-google-maps'

export default {
  props:{
    showStreetView: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      panorama: null
    }
  },
  methods: {
    init: function () {
      this.panorama = this.map.getStreetView()
      this.panorama.setOptions({
        addressControl: false,
        fullscreenControl: false,
        linksControl: true,
        zoomControl: false,
        enableCloseButton: false,
        imageDateControl: false
      })
      this.panorama.addListener("visible_changed", () => {
        this.$emit('onStreetView', this.panorama.getVisible())
      })
    },
    close: function () {
      this.panorama.setVisible(false)
    }
  },
  computed: {
    ...mapGetters({
      map: 'googleMap/getMap',
    }),
    google: gmapApi
  }
}
</script>
